export const selectLockRecordError = (state) => state.lockRecord.error;

export const selectLockRecordByRecordType = (state) => state.lockRecord.byRecordType;
